export function LogoMark({ size = 34 }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            fill="none"
            aria-hidden="true"
        >
            <g transform="translate(32 32)" fill="#FF5500">
                <rect x="-4" y="-27" width="8" height="12" rx="2.5" />
                <rect
                    x="-4"
                    y="-27"
                    width="8"
                    height="12"
                    rx="2.5"
                    transform="rotate(45)"
                />
                <rect
                    x="-4"
                    y="-27"
                    width="8"
                    height="12"
                    rx="2.5"
                    transform="rotate(90)"
                />
                <rect
                    x="-4"
                    y="-27"
                    width="8"
                    height="12"
                    rx="2.5"
                    transform="rotate(135)"
                />
                <rect
                    x="-4"
                    y="-27"
                    width="8"
                    height="12"
                    rx="2.5"
                    transform="rotate(180)"
                />
                <rect
                    x="-4"
                    y="-27"
                    width="8"
                    height="12"
                    rx="2.5"
                    transform="rotate(225)"
                />
                <rect
                    x="-4"
                    y="-27"
                    width="8"
                    height="12"
                    rx="2.5"
                    transform="rotate(270)"
                />
                <rect
                    x="-4"
                    y="-27"
                    width="8"
                    height="12"
                    rx="2.5"
                    transform="rotate(315)"
                />
            </g>
            <circle cx="32" cy="32" r="10" fill="#0D0F12" />
            <circle cx="32" cy="32" r="3" fill="#F4F5F6" />
        </svg>
    );
}

export default function Logo({ light = true }) {
    return (
        <span className="flex items-center gap-3" data-testid="brand-logo">
            <LogoMark />
            <span
                className={`font-display text-lg font-extrabold uppercase tracking-wide ${
                    light ? "text-paper" : "text-ink"
                }`}
            >
                CAROTE<span className="text-flame">.RO</span>
            </span>
        </span>
    );
}